<template>
    <div class="planningReport">
        <div class="content">
            
            <PlanReport :title="planReportTitle" :plan="plan" :version='version'></PlanReport>
        </div>
        <div class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
            <Button @handleClick="$router.go(-1)" :type="'btnGray'" name="返回" ></Button>
        </div>
    </div>
</template>
<script>
import CareerReport from '@/components/consultant/planningContent/CareerReport.vue'
import PlanReport from '@/components/consultant/planningContent/PlanReport.vue'
import Button from '@/components/Button.vue'
export default {
    name: "planningReport",
    components: {
        PlanReport,
        CareerReport,
        Button
    },
    data() {
        return {
            userType: 1,
            studentId: sessionStorage.getItem('myStudentStudentId'),//学生id
            planReportTitle: '学业发展规划',
            id: this.$route.query.id,
            plan: {},
            version:'',
        }
    },
    methods: {
        getPlanById(){
            let id = this.id;
            this.$ajax.post(this.G_acapi + this.ports.student.student.planningContent.getPlanByIdByStudent,{
                id: id
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data = res.data;
                if (data.code == 2000) {
                    console.log(data)
                    this.plan = res.data.data;
                    this.version = res.data.data.version
                }
            })
        },
    },
    created() {
        this.getPlanById();
    }
}
</script>

<style scoped lang="less">
.planningReport {
    .titleBox {
        overflow: hidden;
        .title{
            font-size: 32px;
            font-weight: bolder;
            line-height: 80px;
            text-align: center;
            color:#0094EA;
            float: left;
        }
    }
    .mainBox {
        margin-bottom: 40px;
    }
    .content {
        padding: 30px;
        background-color: #fff;
    }
}
</style>